import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Message from './components/Message.vue'
// Add Element UI imports
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

// Use Element UI
Vue.use(ElementUI)

// 创建消息提示实例
const MessageConstructor = Vue.extend(Message)
const messageInstance = new MessageConstructor()
messageInstance.$mount()
document.body.appendChild(messageInstance.$el)

// 注册全局方法
Vue.prototype.$message = {
  success(text) {
    messageInstance.show(text, 'success')
  },
  warning(text) {
    messageInstance.show(text, 'warning')
  },
  error(text) {
    messageInstance.show(text, 'error')
  },
  info(text) {
    messageInstance.show(text, 'info')
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
